import React, { useState, useEffect } from "react";
import IconWit from "../../../assets/img/icon-witsoccer.png";
import { ImgIcon, Body, MenuOptions, Option } from "./styles";
import { Container } from "react-bootstrap";
import HamburgerMenu from "react-hamburger-menu";
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMenuResponsive, setshowMenuResponsive] = useState(false);
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    setshowMenuResponsive(width < 768)
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return (
    <>
      <Body>
        <Container>
          <ImgIcon src={IconWit} />
          {!showMenuResponsive && (
            <MenuOptions>
              <a href="https://witsoccer.com/#oquee">
                <Option>O que é</Option>
              </a>
              <a href="https://witsoccer.com/#passoapasso">
                <Option>Passo a Passo</Option>
              </a>
              <a href="https://witsoccer.com/#duvidas">
                <Option>Dúvidas</Option>
              </a>
              <a href="https://witsoccer.com/inscricao">
                <Option noColor>Inscrições</Option>
              </a>
            </MenuOptions>
          )}
          {showMenuResponsive && (
            <HamburgerMenu
              isOpen={menuOpen}
              menuClicked={() => setMenuOpen(!menuOpen)}
              width={24}
              height={12}
              strokeWidth={1}
              rotate={0}
              color="#ACE522"
              borderRadius={20}
              animationDuration={0.5}
            />
          )}
        </Container>
      </Body>
      {menuOpen && (
        <div>
          <MenuOptions responsive>
            <a href="https://witsoccer.com/#oquee">
              <Option responsive >O que é</Option>
            </a>
            <a href="https://witsoccer.com/#passoapasso">
              <Option responsive >Passo a Passo</Option>
            </a>
            <a href="https://witsoccer.com/#duvidas">
              <Option responsive >Dúvidas</Option>
            </a>
            <a href="https://witsoccer.com/inscricao">
              <Option responsive noColor>Inscrições</Option>
            </a>
          </MenuOptions>
        </div>
      )}
    </>
  );
}
